<template>
<!-- 
Some modal are loading their content from an HTTP request.
In this case, we need to wait before dispaying the content.

Changes:
- Added the `loading` prop
- Added the `v-show` directive on the `modal-dialog` element
- Added the `backdrop` prop
- Added the `beforeDestroy` to remove body class
- Added the `centered` prop
-->

  <SlideYUpTransition :duration="animationDuration">
    <div class="modal fade" ref="modal"
         @mousedown.self="closeModal"
         :class="[{'show d-block': show}, {'d-none': !show}, {'modal-mini': type === 'mini'}]"
         v-show="show"
         tabindex="-1"
         role="dialog"
         :data-backdrop="backdrop">

      <div class="modal-dialog" v-show="!loading"
           :class="[{'modal-dialog-centered': centered, 'modal-notice': type === 'notice', [`modal-${size}`]: size}, modalClasses]">
        <div class="modal-content" :class="[gradient ? `bg-gradient-${gradient}` : '',modalContentClasses]">

          <div class="modal-header" :class="[headerClasses]" v-if="$slots.header">
            <slot name="header"></slot>
            <slot name="close-button">
              <button type="button"
                      class="close"
                      v-if="showClose"
                      @click="closeModal"
                      data-dismiss="modal"
                      aria-label="Close">
                <span>×</span>
              </button>
            </slot>
          </div>

          <div class="modal-body" :class="bodyClasses">
            <slot></slot>
          </div>

          <div class="modal-footer" :class="footerClasses" v-if="$slots.footer">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>

    </div>
  </SlideYUpTransition>
</template>
<script>
  import { SlideYUpTransition } from "vue2-transitions";

  export default {
    name: "modal",
    components: {
      SlideYUpTransition
    },
    props: {
      backdrop: {
          type: String,
          default: 'true'
      },
      loading: {
          type: Boolean,
          default: false
      },
      show: Boolean,
      showClose: {
        type: Boolean,
        default: true
      },
      centered: {
        type: Boolean,
        default: true
      },
      type: {
        type: String,
        default: "",
        validator(value) {
          let acceptedValues = ["", "notice", "mini"];
          return acceptedValues.indexOf(value) !== -1;
        },
        description: 'Modal type (notice|mini|"") '
      },
      modalClasses: {
        type: [Object, String],
        description: "Modal dialog css classes"
      },
      size: {
        type: String,
        description: 'Modal size',
        validator(value) {
          let acceptedValues = ["", "sm", "lg", "xl"];
          return acceptedValues.indexOf(value) !== -1;
        },
      },
      modalContentClasses: {
        type: [Object, String],
        description: "Modal dialog content css classes"
      },
      gradient: {
        type: String,
        description: "Modal gradient type (danger, primary etc)"
      },
      headerClasses: {
        type: [Object, String],
        description: "Modal Header css classes"
      },
      bodyClasses: {
        type: [Object, String],
        description: "Modal Body css classes"
      },
      footerClasses: {
        type: [Object, String],
        description: "Modal Footer css classes"
      },
      animationDuration: {
        type: Number,
        default: 500,
        description: "Modal transition duration"
      }
    },
    methods: {
      closeModal() {
        if (this.backdrop != 'static') {
          this.$emit("update:show", false);
          this.$emit("close");
        }
      }
    },
    watch: {
      show(val) {
        let documentClasses = document.body.classList;
        if (val) {
          documentClasses.add("modal-open");
        } else {
          documentClasses.remove("modal-open");
        }
      }
    },
    beforeDestroy() {
      document.body.classList.remove("modal-open");
    }
  };
</script>
<style>
  .modal.show {
    background-color: rgba(0, 0, 0, 0.3);
  }
  @media (min-width: 576px) {
    .modal-xl {
        max-width: 530px;
    }
  }
  @media (min-width: 768px) {
    .modal-xl {
        max-width: 748px;
    }
  }
  @media (min-width: 992px) {
    .modal-xl {
        max-width: 950px;
    }
  }
  @media (min-width: 1200px) {
    .modal-xl {
        max-width: 1140px;
    }
  }
</style>
